import { createPosition } from "@shared/common/utils/create";
import shortUUID from "short-uuid";
import type { IFormImageVideoNode, PartialNode } from "../type";

const createFormImageVideoNode = (
  data?: PartialNode<IFormImageVideoNode>
): IFormImageVideoNode => {
  return {
    type: "FORM_IMAGE_VIDEO",
    id: shortUUID.generate(),
    pluginData: {
      contentEditorPropSeq: 0,
      contentMeta: [],
    },
    reactions: [],
    position: createPosition(data?.position),

    name: "",

    width: { value: 100, unit: "%" },

    fills: [],

    locked: false,

    strokes: [],
    strokeWeight: 1,
    strokeAlign: "CENTER",
    strokeCap: "SQUARE",
    strokeJoin: "ROUND",
    dashPattern: [],

    visible: true,

    effects: [],

    label: "<p>새 이미지</p>",
    required: false,

    cornerRadius: {
      bl: { unit: "px", value: 4 },
      br: { unit: "px", value: 4 },
      tl: { unit: "px", value: 4 },
      tr: { unit: "px", value: 4 },
    },

    margin: {
      top: { value: 5, unit: "px" },
      bottom: { value: 5, unit: "px" },
    },
    ...data,
  };
};

export default createFormImageVideoNode;
